import { FC, memo } from 'react'

import { HrProps } from './HrProps'

import { SCHr } from './styles'

export const Hr: FC<HrProps> = memo((props) => <SCHr {...props} />)
